<h2>{{otpService.error.errorTitle}}</h2>
<p *ngFor="let errorMessage of otpService.error.errorMessages">{{errorMessage | parseOtpErrorMessage}}</p>
<div fxLayout="row wrap" class="form-row-container" fxLayoutGap.xs="0" fxLayoutGap.gt-xs="20px">
  <button class="btn btn-chevron" id="cancel-button" mat-raised-button color="action" (click)="logout()" fxFlex.xs="100" fxFlexOrder.xs="2" fxFlexOrder.gt-xs="0">
    <span>Back to Login</span>
    <mat-icon fontSet="iinet-icons" fontIcon="iii-point-thin"></mat-icon>
  </button>
</div>
